import 'whatwg-fetch';
import Highway from '@dogstudio/highway';

// renderers
import PageRenderer from './renderers/page';
import ModalRenderer from './renderers/modal';

// transitions
import PageTransition from './transitions/page';
import ModalTransition from './transitions/modal';

// components
import Nav from './components/nav/nav';
import NavSidebar from './components/nav/sidebar';
import NavMobile from './components/nav/mobile';
import MapAside from './components/map-aside/map-aside';
import BackToTop from './components/back-to-top/back-to-top';
import Error from './components/404/404';

// styles
import './index.scss';

(() => {
  const nav = new Nav();
  const navSidebar = new NavSidebar();
  const navMobile = new NavMobile();

  // init navbar
  if (nav.state.isMobile) navMobile.initNav();
  else navSidebar.initNav();

  // init map aside
  if (document.querySelector('.js-map-aside')) {
    const mapAside = new MapAside();
    mapAside.initMapAside();
  }

  // init back to top button
  const backToTop = new BackToTop();
  backToTop.init();

  // init error page
  const error = new Error();
  error.init();

  // set min height content to push footer down
  const content = document.querySelector('.js-content');
  const footer = document.querySelector('.js-footer');

  content.style.minHeight = `${window.innerHeight - footer.offsetHeight}px`;

  // some highway stuff
  const links = document.querySelectorAll('.nav__link');
  const activeLink = document.querySelector(`[href='${window.location.href}']`);

  // set active nav item on initial page load
  if (activeLink) activeLink.classList.add('nav__link--active');

  const H = new Highway.Core({
    renderers: {
      page: PageRenderer,
      modal: ModalRenderer
    },
    transitions: {
      default: PageTransition,
      modal: ModalTransition
    }
  });

  H.on('NAVIGATE_IN', (to, location) => {
    [...links].forEach((link) => {
      // remove active class
      link.classList.remove('nav__link--active');

      // set active class
      if (link.href === location.href) {
        link.classList.add('nav__link--active');
      }
    });
  });
})();
